import cn from 'classnames';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { useMedia } from '@/shared/hooks';

import styles from './ReportVersions.module.scss';

type ReportVersionsProps = {
  className?: string;
  children: ReactNode;
};

export const ReportsVersions = (props: ReportVersionsProps) => {
  const { className, children } = props;

  const { formatMessage } = useIntl();
  const { isMobile } = useMedia();

  return (
    <section
      className={cn(styles.container, className)}
      data-section="report-versions"
    >
      <header className={styles.header}>
        <h4 className={cn({ h4: !isMobile, h2m: isMobile })}>
          {formatMessage({
            id: 'reportVersions.title',
            defaultMessage: 'Reports Versions',
          })}
        </h4>
      </header>
      <main className={styles.main}>{children}</main>
    </section>
  );
};
